import axiosInstance from "./config";

const basePath = `/induk-app/categories`;

export const getCategories = (page?: number, search?: string) => {
  return axiosInstance.get(`${basePath}`, {
    params: {
      page,
      search,
    },
  });
};

export const addCategory = (category: {
  name: string;
  description: string | null;
  image: File | null;
}) => {
  const formData = new FormData();
  Object.entries(category).forEach(([key, value]) => {
    if (value === null || value === undefined) return;
    formData.append(key, value);
  });

  return axiosInstance.post(`${basePath}/create`, formData);
};

export const getCategory = (slug: string) => {
  return axiosInstance.get(`${basePath}/${slug}`);
};

export const updateCategory = (
  slug: string,
  category: {
    name: string;
    description: string | null;
    image: File | null;
  }
) => {
  const formData = new FormData();
  if (category.image) {
    Object.entries(category).forEach(([key, value]) => {
      if (value === null || value === undefined) return;
      formData.append(key, value);
    });
  }

  const payload = category.image ? formData : category;

  return axiosInstance.patch(`${basePath}/${slug}/update`, payload);
};

export const deleteCategory = (slug: string) => {
  return axiosInstance.delete(`${basePath}/${slug}/delete`);
};
